/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import colors from 'ui/styles/colors.module.scss';
import Text from '../text';

import s from './styles.module.scss';

const statusColors = {
  green: colors.success,
  yellow: colors.warning,
  red: colors.error,
  blue: colors.statusBlue,
};

const DeviceStatus = ({ status, color }) => (
  <div className={s.wrapper}>
    <Text
      size={Text.size.s}
      weight={Text.weight.medium}
      className={s.status}
      style={{ backgroundColor: statusColors[color] || color }}
    >
      {status}
    </Text>
  </div>
);

DeviceStatus.propTypes = {
  status: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};

export default DeviceStatus;
